

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Tabs,
  Tab,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { getalllocations, getalloutlettype } from "../../assign-task/api";
import DatePicker from "react-datepicker";
import calendarIcon from "../../../src/assests/images/calendar.svg";
import calendar from "../../../src/assests/images/calendar.svg";
import arrowLeft from "../../../assests/images/arrow-left.svg";

import arrowRight from "../../../assests/images/arrow-right.png";

import doubleArrowLeft from "../../../assests/images/double-arrow-left.svg";

import doubleArrowRight from "../../../assests/images/double-arrow-right.svg";
import { string } from "yup";
interface Filters {
  locations: { [key: string]: boolean };
  outlettype: { [key: string]: boolean };
  lastlogin: { [key: string]: boolean };
}

interface FilterPopupProps {
  filter: any;
  onApplyFilters: (filters: { locations: string[]; outletTypes: string[]; lastlogin: string[] }) => void;
  selectedDate: Date | null;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
  selectedlastlogin: string[]; // ✅ Added this
  setSelectedlastlogin: React.Dispatch<React.SetStateAction<string[]>>;
  selectedTab: number;
  setSelectedTab: (tabIndex: number) => void;
}

const FilterPopup: React.FC<FilterPopupProps> = ({ onApplyFilters, setSelectedDate, selectedDate, selectedlastlogin, setSelectedlastlogin, selectedTab, setSelectedTab }) => {
  // const [selectedTab, setSelectedTab] = useState(0);
  // const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  const [filters, setFilters] = useState<Filters>({
    locations: { all: true },
    outlettype: { all: true },
    lastlogin: { today: true, last2Days: false, last3Days: false, last1Week: false, MoreThan15Days: false },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTab === 0) {
          const response = await getalllocations();
          setFilters((prev) => {
            const newLocations = response.data.data.reduce((acc: any, city: any) => {
              // Preserve existing values if they exist
              acc[city] = prev.locations?.[city] ?? false;
              return acc;
            }, { all: prev.locations?.all ?? true });
            return { ...prev, locations: newLocations };
          });
        }
        if (selectedTab === 1) {
          const response = await getalloutlettype();
          setFilters((prev) => {
            const newOutletTypes = response.data.data.reduce((acc: any, type: any) => {
              // Preserve existing values if they exist
              acc[type] = prev.outlettype?.[type] ?? false;
              return acc;
            }, { all: prev.outlettype?.all ?? true });
            return { ...prev, outlettype: newOutletTypes };
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedTab]);


  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };


  // const handleFilterClick = (filterType: keyof Filters, key?: string) => {
  //   setFilters((prev) => {
  //     if (filterType === "lastlogin") {
  //       // Handle Last Login separately
  //       let newDate: Date | null = null;
  //       const today = new Date();
  //       switch (key) {
  //         case "today":
  //           newDate = today;
  //           break;
  //         case "last1Week":
  //           newDate = new Date(today);
  //           newDate.setDate(today.getDate() - 7);
  //           break;
  //         case "moreThan15Days":
  //           newDate = new Date(today);
  //           newDate.setDate(today.getDate() - 15);
  //           break;
  //         case "last3Days":
  //           newDate = new Date(today);
  //           newDate.setDate(today.getDate() - 3);
  //           break;
  //         case "last2Days":
  //           newDate = new Date(today);
  //           newDate.setDate(today.getDate() - 2);
  //           break;
  //         default:
  //           newDate = null;
  //       }
  //       setSelectedDate(newDate);
  //       return {
  //         ...prev,
  //         lastlogin: { ...prev.lastlogin, [key!]: !prev.lastlogin[key!] },
  //       };
  //     } else {
  //       // Handle locations and outlettype
  //       if (key === "all") {
  //         const allChecked = !prev[filterType]["all"];
  //         const updatedFilters = Object.keys(prev[filterType]).reduce(
  //           (acc, curr) => {
  //             acc[curr] = allChecked;
  //             return acc;
  //           },
  //           {} as { [key: string]: boolean }
  //         );
  //         return { ...prev, [filterType]: updatedFilters };
  //       } else {
  //         return {
  //           ...prev,
  //           [filterType]: {
  //             ...prev[filterType],
  //             [key!]: !prev[filterType][key!],
  //             all: false, // Unselect "all" when individual options are selected
  //           },
  //         };
  //       }
  //     }
  //   });
  // };


  const handleFilterClick = (filterType: keyof Filters, key?: string) => {
    console.log(key, "bbbbbbbhhhhhhhhhhh", filterType, "filterTypefilterTypefilterTypefilterType")
    setFilters((prev) => {
      if (filterType === "lastlogin") {
        const updatedLastLogin = Object.keys(prev.lastlogin).reduce(
          (acc, curr) => {
            acc[curr] = curr === key ? !prev.lastlogin[key!] : false;
            return acc;
          },
          {} as { [key: string]: boolean }
        );

        let newDate: Date | null = null;
        const today = new Date();

        switch (key) {
          case "Today":
            newDate = today;
            break;
          case "Last1Week":
            newDate = new Date(today);
            newDate.setDate(today.getDate() - 7);
            break;
          case "MoreThan15Days":
            newDate = new Date(today);
            newDate.setDate(today.getDate() - 15);
            break;
          case "Last3Days":
            newDate = new Date(today);
            newDate.setDate(today.getDate() - 3);
            break;
          case "Last2Days":
            newDate = new Date(today);
            newDate.setDate(today.getDate() - 2);
            break;
          default:
            newDate = null;
        }

        setSelectedDate(newDate);

        return {
          ...prev,
          lastlogin: updatedLastLogin,
        };
      } else {
        if (key === "all") {
          const allChecked = !prev[filterType]["all"];
          const updatedFilters = Object.keys(prev[filterType]).reduce(
            (acc, curr) => {
              acc[curr] = allChecked;
              return acc;
            },
            {} as { [key: string]: boolean }
          );
          return { ...prev, [filterType]: updatedFilters };
        } else {
          return {
            ...prev,
            [filterType]: {
              ...prev[filterType],
              [key!]: !prev[filterType][key!],
              all: false, // Unselect "all" when individual options are selected
            },
          };
        }
      }
    });
    console.log(filters, "filterssssssssssaaaaaaaaaaaaaaaaaaaaa")
  };


  const clearAllFilters = () => {
    setFilters({
      locations: { all: true },
      outlettype: { all: true },
      lastlogin: { Today: true, Last2Days: false, Last3Days: false, Last1Week: false, MoreThan15Days: false },
    });
  };
  // const [selectedlastlogin, setSelectedlastlogin] = useState<string[]>([]);

  const selectedlastlogins = Object.keys(filters.lastlogin).filter((key) => filters.lastlogin[key] && key !== "all");
  console.log(selectedlastlogin, "selectedlastloginfffffffffffffffff")
  const handleApply = () => {
    const selectedLocations = Object.keys(filters.locations).filter((key) => filters.locations[key] && key !== "all");
    const selectedOutletTypes = Object.keys(filters.outlettype).filter((key) => filters.outlettype[key] && key !== "all");
    const selectedlastlogin = Object.keys(filters.lastlogin).filter((key) => filters.lastlogin[key] && key !== "all");
    setSelectedlastlogin(selectedlastlogin)
    onApplyFilters({ locations: selectedLocations, outletTypes: selectedOutletTypes, lastlogin: selectedlastlogin });
  };
  console.log(selectedlastlogin, "selectedlastloginselectedlastlogin")
  const tabsConfig = [
    { label: "Location", key: "locations" },
    { label: "Outlet Type", key: "outlettype" },
    { label: "Last Login", key: "lastlogin" },
  ];


  useEffect(() => {
    console.log("Updated selectedDate:", selectedDate);
  }, [selectedDate]);

  console.log(filters, "filtersfiltersfilterssssswwww")

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={popupStyle}>
        <Box sx={{ width: "100%", display: "flex" }}>
          <Box sx={{ width: "200px", borderRight: "1px solid #ddd" }}>
            <Tabs orientation="vertical" value={selectedTab} onChange={handleTabChange} sx={tabContainerStyle}>
              {tabsConfig.map((tab, index) => (
                <Tab key={tab.key} label={tab.label} sx={tabStyles} />
              ))}
            </Tabs>
          </Box>

          <Box sx={{ paddingLeft: "20px", flexGrow: 1 }}>
            {tabsConfig.map((tab, index) =>
              selectedTab === index ? (
                <Box key={tab.key} sx={{ marginBottom: "16px" }}>

                  {/* {tab.key !== "lastlogin" && (
        <FormControlLabel
        control={
          <Checkbox
            checked={filters[tab.key as keyof Filters]["all"]}
            onChange={() => handleFilterClick(tab.key as keyof Filters)} 
            name="all"
          />
        }
        label="Select All"
      />
        )} */}

                  <Box>
                    {tab.key !== "lastlogin" && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={filters[tab.key as keyof Filters]["all"]}
                            onChange={() => handleFilterClick(tab.key as keyof Filters, "all")}
                            name="all"
                          />
                        }
                        label="Select All" sx={{ paddingLeft: "10px" }}

                      />
                    )}

                    {Object.keys(filters[tab.key as keyof Filters])
                      .filter((key) => key !== "all")
                      .map((filterKey) => (
                        <Box key={filterKey} sx={{ display: "flex", alignItems: "center" }}>



                          {tab.key !== "lastlogin" && (
                            <Checkbox
                              checked={filters[tab.key as keyof Filters][filterKey]}
                              onChange={() => handleFilterClick(tab.key as keyof Filters, filterKey)}
                              name={filterKey}
                            />
                          )}

                          <Typography
                            sx={{
                              fontSize: "16px",
                              padding: "10px",
                              cursor: "pointer",
                              transition: "color 0.3s ease",
                              //  "&:hover": { background: "#EEF4FF" },
                              background: selectedTab === 2 && filters.lastlogin[filterKey] ? "#EEF4FF" : "transparent",
                              "&:hover": selectedTab === 2 ? { background: "#EEF4FF" } : {},
                            }}
                            onClick={() => handleFilterClick(tab.key as keyof Filters, filterKey)}
                          >
                            {filterKey.charAt(0).toUpperCase() + filterKey.slice(1)}
                          </Typography>
                        </Box>
                      ))}

                  </Box>
                </Box>
              ) : null
            )}
          </Box>

          <Box>
            {selectedTab === 2 && (
              <Box>

                <style>
                  {`
     .static-datepicker {
      position: static !important;
      box-shadow: none !important; /* Removes box shadow */
      border: 0px solid #ddd; /* Optional: Add border if needed */

    }
    `}
                </style>


                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    console.log(date, "Selected Date");
                  }}
                  inline
                  calendarClassName="static-datepicker"
                  dayClassName={(date) =>
                    selectedDate && date.toDateString() === selectedDate.toDateString()
                      ? "selected-date"
                      : ""
                  }
                  renderCustomHeader={({ date, decreaseMonth, increaseMonth, decreaseYear, increaseYear }) => (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <button onClick={decreaseYear}>
                        <img src={doubleArrowLeft} alt="double left arrow" />
                      </button>
                      <button onClick={decreaseMonth}>
                        <img src={arrowLeft} alt="left arrow" />
                      </button>
                      <span style={{ margin: "0 10px" }}>
                        {date.toLocaleString("default", { year: "numeric", month: "long" })}
                      </span>
                      <button onClick={increaseMonth}>
                        <img src={arrowRight} alt="right arrow" />
                      </button>
                      <button onClick={increaseYear}>
                        <img src={doubleArrowRight} alt="double right arrow" />
                      </button>
                    </div>
                  )}
                />

                <style>
                  {`
  /* Apply red circle to selected date */
  .static-datepicker .react-datepicker__day--selected {
    background-color: #F14B56 !important; /* Red circle */
    color: white !important;
    border-radius: 50%;
  }
  
  /* Ensure no extra selection styles appear */
  .static-datepicker .react-datepicker__day--keyboard-selected {
    background-color: transparent !important; /* Remove default selection */
    color: inherit !important;
  }
`}
                </style>

              </Box>
            )}
          </Box>
        </Box>



        <Box sx={buttonContainerStyle}>
          <Button sx={clearButtonStyles} onClick={clearAllFilters}>
            Clear All
          </Button>
          <Button sx={applyButtonStyles} onClick={handleApply}>
            Apply
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

// Styles
const popupStyle = {
  position: "absolute",
  // width: "400px",
  right: "3%",
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  zIndex: 9999,
};

const tabContainerStyle = {
  borderRight: 1,
  borderColor: "divider",
  whiteSpace: "nowrap",
  fontSize: "14px",
  color: "#282829",
  fontWeight: "500",
  textAlign: "left",
};

const tabStyles = {
  whiteSpace: "nowrap",
  fontSize: "14px",
  color: "#282829",
  fontWeight: "500",
  textTransform: "capitalize",
  alignItems: "start",
  "&:hover": { backgroundColor: "#F9FBFC" },
  "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
};

const buttonContainerStyle = {
  marginTop: "1rem",
  width: "100%",
  justifyContent: "end",
  display: "flex",
  borderTop: "1px solid #ddd",
};

const clearButtonStyles = {
  border: "1px solid #E7E8E9",
  color: "#000",
  marginTop: "20px",
  borderRadius: "10px",
  marginRight: "10px",
  height: "44px",
  padding: "15px 15px",
};

const applyButtonStyles = {
  border: "1px solid #C8172F",
  color: "#C8172F",
  marginTop: "20px",
  borderRadius: "10px",
  height: "44px",
  padding: "15px 15px",
};

export default FilterPopup;